/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CrownImageType } from '../../CrownDesc';
import { LuminanceFormat, RGBFormat } from 'three';
/**
 * Create a TypeConfiguration of the specified CrownImageType.
 * Used for mapping raw image data on to texture.
 */
export class ImageTypeConfigurationFactory {
    createForType(imageType) {
        switch (imageType) {
            case CrownImageType.RGB24:
                return this._createForRGB24();
            case CrownImageType.UINT8:
                return this._createForUINT8();
            case CrownImageType.UINT16:
                return this._createForUINT16();
            default:
                throw new Error(`Type '${imageType} is not supported`);
        }
    }
    _createForRGB24() {
        const configuration = {
            stride: 3,
            textureFormat: RGBFormat,
        };
        return configuration;
    }
    _createForUINT8() {
        const configuration = {
            stride: 1,
            textureFormat: LuminanceFormat,
        };
        return configuration;
    }
    _createForUINT16() {
        const configuration = {
            stride: 2,
            textureFormat: LuminanceFormat,
        };
        return configuration;
    }
}
//# sourceMappingURL=ImageTypeConfigurationFactory.js.map